module.exports = __webpack_public_path__ + "img/2-2.94b95a35.jpg";